/*
 * Licensed Materials - Property of IBM
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 * 
 * SD-1067 - Implemented this component for create survey at the end of the
 * application submission
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'Survey_Title',
    defaultMessage: 'Survey Questions',
  },
  validationMessage: {
    id: 'Survey_ValidationMessage',
    defaultMessage: '  Please enter a valid value for',
  },
  pageDescription: {
    id: 'Survey_PageDescription',
    defaultMessage: 'Please provide us your feedback about your online experience.',
  },
});
